export default __webpack_public_path__ + "static/media/Gabriel West.eec77907.jpg";